import { render, staticRenderFns } from "./StudentListByIntake.vue?vue&type=template&id=050a0320"
import script from "./StudentListByIntake.vue?vue&type=script&lang=js"
export * from "./StudentListByIntake.vue?vue&type=script&lang=js"
import style0 from "./StudentListByIntake.vue?vue&type=style&index=0&id=050a0320&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports